let servidor; 
import 'dotenv/config'
import axios from 'axios'
import store from '@/store'

try {
   servidor = require('./servidor')
} catch (error) {
    servidor = {
        node_env: 'development'
    }
}

var baseURL = 'https://default.api-rd.homo.ipdvonline.com.br';
///////////
// Vamos dar preferência para as variáveis de ambiente ao invés de usar o arquivo de configuração
/////////
if(servidor.node_env == 'devla'){

    baseURL = process.env.VUE_APP_DEVLA_URL ||  'http://raia-api-la.ipdvlnx.com.br:3990'
}

if(servidor.node_env == 'development'){

    baseURL = process.env.VUE_APP_DEVELOPMENT_URL ||  'http://localhost:3800'
}

if(servidor.node_env == 'production_local'){

    baseURL = 'http://localhost:3300'
}

if(servidor.node_env == 'test'){

    baseURL = process.env.VUE_APP_TEST_URL ||  'http://raia-api.readpdv.com.br'
}

if(servidor.node_env == 'production'){

    baseURL = process.env.VUE_APP_PRODUCTION_URL ||  'https://api-trade.rdtrade.com.br'
}

baseURL =  process.env.VUE_APP_BASE_URL || baseURL

export const http = (tipo = 'http') => {
    // console.log('baseURL', {
    //     baseURL,
    //     env:process.env.VUE_APP_BASE_URL,
    //     servidor:servidor,
    //     env_completo: process.env
    // })

    var http = axios.create({
        baseURL: baseURL,
        timeout: 0,   // 0 = sem timeout
        params: {
            x: Date.now()
        },
        headers: {
            token: store.getters.getToken
        },
    })

    http.interceptors.response.use((response) => {

        return response
    }, (error) => {
        error.erro = true;

        if (error.response?.status == 401) {
            store.dispatch('sessaoExpirou')
            // Devolve a resposta como nos demais erros, em vez de `return` seco.
            // Retornando undefined, TODA chamada em voo no momento da expiracao
            // estourava em `response.data` — as telas abertas ainda tem requests
            // pendentes em created/beforeCreate quando o redirect pro login
            // acontece, e o erro aparecia no RUM carimbado na view `login`.
            error.response.erro = true
            return error.response
        }
        if(error.response){
            error.response.erro = true;
            return error.response;
        }
        return error
    })

    if(tipo == 'http') {

        return http
    }
    if(tipo == 'baseURL') {

        return baseURL
    }    
}